import React from 'react';

const NodeFolderSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M1 4.46482C1 3.84705 1 3.53816 1.04855 3.28087C1.26225 2.14822 2.14822 1.26225 3.28087 1.04855C3.53816 1 3.84705 1 4.46482 1C4.73549 1 4.87083 1 5.0009 1.01217C5.56165 1.0646 6.09356 1.28493 6.52716 1.64436C6.62772 1.72773 6.72341 1.82343 6.91479 2.01482L7.3 2.4C7.87106 2.97105 8.15659 3.25657 8.49847 3.4468C8.68628 3.5513 8.88557 3.63382 9.09228 3.69275C9.46853 3.8 9.87229 3.8 10.6799 3.8H10.9415C12.7842 3.8 13.7054 3.8 14.3043 4.33862C14.3594 4.38817 14.4119 4.4406 14.4613 4.49568C15 5.09455 15 6.01588 15 7.85853V9.4C15 12.0398 15 13.3598 14.1799 14.1799C13.3598 15 12.0398 15 9.4 15H6.6C3.96013 15 2.6402 15 1.8201 14.1799C1 13.3598 1 12.0398 1 9.4V4.46482Z"
        stroke={color}
      />
    </svg>
  );
};

export default NodeFolderSVG;
